<template>
  <div :class="$style.errors">
    <div class="pt-4 pb-4 d-flex align-items-end mt-auto">
      <!-- <img src="resources/images/air-logo.png" alt="AIR UI Logo" /> -->
      <!--   <div class="air__utils__logo__text">
        <div class="air__utils__logo__name text-uppercase text-dark font-size-21">Acquire</div>
        <div class="air__utils__logo__descr text-uppercase font-size-12 text-gray-6">Solutions</div>
      </div> -->
    </div>
    <div class="pl-5 pr-5 pt-5 pb-5 mb-auto text-dark font-size-30" :class="$style.container">
      <div class="font-weight-bold mb-3">Página não encontrada</div>
      <div>A página acessada não foi encontrada</div>
      <div class="font-weight-bold font-size-70 mb-1">404 —</div>
      <router-link to="/" class="btn btn-outline-primary width-100">Voltar</router-link>
    </div>
    <div class="mt-auto pb-5 pt-5">

      <div class="text-gray-4 text-center"><acquire-copyright /></div>
    </div>
  </div>
</template>
<script>
import AcquireCopyright from '@/components/layout/Footer/copy.vue'

export default {
  name: 'AirError404',
  components: {
    AcquireCopyright
  }
}
</script>
<style lang="scss" module>
@use '@/components/system/Errors/style.module.scss' as style;
</style>
